module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shippingAddress":"Shipping address","billingAddress":"Billing address","shippingMethod":"Shipping method","paymentDetails":"Payment details","edit":"Edit"},"de":{"paymentDetails":"Zahlungsdetails","shippingMethod":"Versandart","shippingAddress":"Lieferanschrift","billingAddress":"Rechnungsadresse","edit":"Bearbeiten"}}')
  delete Component.options._Ctor
}
